const STORAGE_KEY = 'codewavee_db_v1';

const seed = {
  users: [
    { id: 'child-1', type: 'child', name: 'أحمد', points: 120, badges: ['starter'], parentId: 'parent-1' },
    { id: 'parent-1', type: 'parent', name: 'ولي أمر أحمد' }
  ],
  quizzes: [],
  progress: [],
  chats: [],
  subscriptionPlans: [
    {
      id: 'plan-monthly',
      name: '🟢 Monthly Plan',
      price: 1500,
      priceLabel: '1500 EGP',
      description: '8 Live Private Sessions, recordings, WhatsApp support.',
      durationMonths: 1,
      sessionsCount: 8,
      benefits: [
        '8 Live Private Sessions (1 hour each)',
        'Session recordings',
        'WhatsApp support'
      ]
    },
    {
      id: 'plan-quarter',
      name: '🟡 3-Month Plan',
      price: 4000,
      priceLabel: '4000 EGP (instead of 4500)',
      description: '24 live sessions, monthly evaluation, access to all benefits.',
      durationMonths: 3,
      sessionsCount: 24,
      benefits: [
        '24 Live Sessions',
        'Monthly evaluation',
        'Session recordings and WhatsApp support'
      ]
    },
    {
      id: 'plan-6month',
      name: '🔴 6-Month Plan',
      price: 7500,
      priceLabel: '7500 EGP (instead of 9000)',
      description: '48 live sessions, graduation project with direct supervision, all benefits.',
      durationMonths: 6,
      sessionsCount: 48,
      benefits: [
        '48 Live Sessions',
        'Graduation project with direct supervision',
        'All previous benefits'
      ]
    },
    {
      id: 'plan-annual',
      name: '🔥 Annual Plan – Best Value',
      price: 13500,
      priceLabel: '13,500 EGP (Save 4,500)',
      description: '96 live sessions, elite real-world projects, career roadmap, and 1-on-1 supervision.',
      durationMonths: 12,
      sessionsCount: 96,
      benefits: [
        '96 Live Private Sessions (1 hour each)',
        'Weekly progress evaluation',
        'Full access to all recordings',
        'Priority WhatsApp support',
        '2 Real-world Projects',
        'Final Graduation Project (1-on-1)',
        'Career guidance & roadmap',
        'All previous benefits'
      ]
    }
  ]
};

function read() {
  const raw = localStorage.getItem(STORAGE_KEY);
  if (!raw) return seed;

  const data = JSON.parse(raw);
  // تأكد من وجود الخطة السنوية لو مش موجودة في الـ local storage القديم
  if (!data.subscriptionPlans?.find(p => p.id === 'plan-annual')) {
    localStorage.removeItem(STORAGE_KEY); // مسح البيانات القديمة لتحديثها من الـ seed الجديد
    return seed;
  }

  return data;
}
function write(data) {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
}
export function getUser(id = 'child-1') {
  return read().users.find(u => u.id === id);
}
export function saveProgress(progressItem) {
  const db = read();
  db.progress = db.progress.filter(p => !(p.userId === progressItem.userId && p.lessonId === progressItem.lessonId));
  db.progress.push(progressItem);
  write(db);
  return progressItem;
}
export function addChat(chat) {
  const db = read();
  if (!db.chats) db.chats = [];
  db.chats.push(chat);
  write(db);
  return chat;
}
export function getChats(userId = 'child-1') {
  const db = read();
  return (db.chats || []).filter(c => c.userId === userId);
}
export function addPoints(userId, points) {
  const db = read();
  const user = db.users.find(u => u.id === userId);
  if (user) user.points = (user.points || 0) + points;
  write(db);
  return user;
}
export function getProgress(userId = 'child-1') {
  const db = read();
  return db.progress.filter(p => p.userId === userId);
}
export function getParentOverview() {
  const db = read();
  const child = db.users.find(u => u.type === 'child');
  const progress = db.progress.filter(p => p.userId === child.id);
  return { child, progress };
}
export function getSubscriptionPlans() {
  return read().subscriptionPlans || [];
}
export function getSubscriptionPlan(id) {
  return (read().subscriptionPlans || []).find(p => p.id === id);
}
export function saveUserSelectedPlan(userId = 'child-1', planId) {
  const db = read();
  const user = db.users.find(u => u.id === userId);
  if (user) user.selectedPlan = planId;
  write(db);
  return { user, plan: getSubscriptionPlan(planId) };
}
export function getUserSelectedPlan(userId = 'child-1') {
  const db = read();
  const user = db.users.find(u => u.id === userId);
  return user && user.selectedPlan ? getSubscriptionPlan(user.selectedPlan) : null;
}
export default { read, write };
